export const normalizeAdsTxtLine = line =>
  String(line ?? '')
    .trim()
    .replace(/ /g, '')
    .toLowerCase();

export const isComparableAdsTxtLine = line => {
  const value = String(line ?? '').trim();
  if (!value || value.includes('#') || value.includes('bbea06d9c4d2853c')) return false;
  return true;
};

/** Returns required lines that are not present in the live domain ads.txt. */
export const getMissingAdsTxtLines = (requiredLines, currentRows) => {
  const required = (requiredLines ?? []).filter(isComparableAdsTxtLine);
  if (!required.length) return [];
  if (!currentRows?.length) return required;

  const currentSet = new Set(currentRows.map(normalizeAdsTxtLine));
  return required.filter(line => !currentSet.has(normalizeAdsTxtLine(line)));
};

const getComparableResellerLineCount = requiredLines =>
  (requiredLines ?? []).filter(isComparableAdsTxtLine).length;

/** `complete` | `partial` | `all_missing` */
export const getResellerLinesStatus = (resellerLines, currentRows) => {
  const requiredCount = getComparableResellerLineCount(resellerLines);
  if (!requiredCount) return null;

  const missingCount = getMissingAdsTxtLines(resellerLines, currentRows).length;
  if (missingCount === 0) return 'complete';
  if (missingCount >= requiredCount) return 'all_missing';
  return 'partial';
};
